{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 120,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Mobility_Plan_Icon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Arrows 2",
      "parent": 2,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.281], "y": [1] }, "o": { "x": [0.654], "y": [0] }, "t": 71, "s": [0] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.219], "y": [0] }, "t": 85, "s": [365] },
            { "i": { "x": [0.652], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 95, "s": [357] },
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 105, "s": [360] },
            { "t": 128, "s": [360], "h": 1 },
            { "t": 129, "s": [0], "h": 1 },
            { "i": { "x": [0.281], "y": [1] }, "o": { "x": [0.654], "y": [0] }, "t": 130, "s": [0] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.219], "y": [0] }, "t": 143, "s": [365] },
            { "i": { "x": [0.652], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 153, "s": [357] },
            { "t": 163, "s": [360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [0.1, -0.05, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [267.7, 262.75, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [3.2, 0],
                    [1.2, 2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-3.1, 0],
                    [-0.9, 3.8],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.8, 3.1],
                    [-2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.5, 2.6],
                    [4, 0],
                    [0, 0],
                    [-0.1, 0.1]
                  ],
                  "v": [
                    [7.05, -3.35],
                    [6.95, -3.15],
                    [0.15, 2.15],
                    [-6.25, -1.85],
                    [-3.75, -1.85],
                    [-3.75, -3.25],
                    [-8.65, -3.25],
                    [-8.65, 1.45],
                    [-7.15, 1.45],
                    [-7.15, -0.75],
                    [0.25, 3.45],
                    [8.55, -3.15],
                    [8.65, -3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.75, 267.55], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-3.2, 0],
                    [-1.2, -2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [3.1, 0],
                    [0.9, -3.8],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0.8, -3.1],
                    [2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.5, -2.6],
                    [-3.9, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.1, 3.25],
                    [-0.3, -2.05],
                    [6.1, 1.95],
                    [3.7, 1.95],
                    [3.7, 3.35],
                    [8.6, 3.35],
                    [8.6, -1.45],
                    [7.1, -1.45],
                    [7.1, 0.75],
                    [-0.3, -3.45],
                    [-8.6, 3.15],
                    [-8.6, 3.45],
                    [-7.1, 3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.6, 257.95], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 68,
      "op": 122,
      "st": 59,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Circle 2",
      "parent": 5,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [261.2, 258.2, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-8.4, -8.6, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 67,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 73,
              "s": [110, 110, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 82,
              "s": [96, 96, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 92,
              "s": [103, 103, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 104,
              "s": [100, 100, 100]
            },
            { "t": 124, "s": [100, 100, 100], "h": 1 },
            { "t": 125, "s": [100, 100, 100], "h": 1 },
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 126,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 131,
              "s": [110, 110, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 140,
              "s": [96, 96, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 150,
              "s": [103, 103, 100]
            },
            { "t": 162, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-8.174, 0],
                    [0, -8.174],
                    [8.174, 0],
                    [0, 8.174]
                  ],
                  "o": [
                    [8.174, 0],
                    [0, 8.174],
                    [-8.174, 0],
                    [0, -8.174]
                  ],
                  "v": [
                    [0, -14.8],
                    [14.8, 0],
                    [0, 14.8],
                    [-14.8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 68,
      "op": 122,
      "st": 59,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Arrows",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.281], "y": [1] }, "o": { "x": [0.654], "y": [0] }, "t": 12, "s": [0] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.219], "y": [0] }, "t": 26, "s": [365] },
            { "i": { "x": [0.652], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 36, "s": [357] },
            { "t": 46, "s": [360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [0.1, -0.05, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [267.7, 262.75, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [3.2, 0],
                    [1.2, 2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-3.1, 0],
                    [-0.9, 3.8],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.8, 3.1],
                    [-2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.5, 2.6],
                    [4, 0],
                    [0, 0],
                    [-0.1, 0.1]
                  ],
                  "v": [
                    [7.05, -3.35],
                    [6.95, -3.15],
                    [0.15, 2.15],
                    [-6.25, -1.85],
                    [-3.75, -1.85],
                    [-3.75, -3.25],
                    [-8.65, -3.25],
                    [-8.65, 1.45],
                    [-7.15, 1.45],
                    [-7.15, -0.75],
                    [0.25, 3.45],
                    [8.55, -3.15],
                    [8.65, -3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.75, 267.55], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-3.2, 0],
                    [-1.2, -2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [3.1, 0],
                    [0.9, -3.8],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0.8, -3.1],
                    [2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.5, -2.6],
                    [-3.9, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.1, 3.25],
                    [-0.3, -2.05],
                    [6.1, 1.95],
                    [3.7, 1.95],
                    [3.7, 3.35],
                    [8.6, 3.35],
                    [8.6, -1.45],
                    [7.1, -1.45],
                    [7.1, 0.75],
                    [-0.3, -3.45],
                    [-8.6, 3.15],
                    [-8.6, 3.45],
                    [-7.1, 3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.6, 257.95], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 68,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Circle",
      "parent": 5,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [261.2, 258.2, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-8.4, -8.6, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 8,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 14,
              "s": [110, 110, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 23,
              "s": [96, 96, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 33,
              "s": [103, 103, 100]
            },
            { "t": 45, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-8.174, 0],
                    [0, -8.174],
                    [8.174, 0],
                    [0, 8.174]
                  ],
                  "o": [
                    [8.174, 0],
                    [0, 8.174],
                    [-8.174, 0],
                    [0, -8.174]
                  ],
                  "v": [
                    [0, -14.8],
                    [14.8, 0],
                    [0, 14.8],
                    [-14.8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 68,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Globe Mask",
      "parent": 7,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [0.14, -0.18, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [249.74, 245.52, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "d": 1,
              "ty": "el",
              "s": { "a": 0, "k": [51.732, 51.732], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "nm": "Ellipse Path 1",
              "mn": "ADBE Vector Shape - Ellipse",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2.4, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [249.74, 245.52], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Ellipse 2",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [14.285, 0],
                    [0, -14.285],
                    [-14.285, 0],
                    [0, 14.285]
                  ],
                  "o": [
                    [-14.285, 0],
                    [0, 14.285],
                    [14.285, 0],
                    [0, -14.285]
                  ],
                  "v": [
                    [0, -25.866],
                    [-25.866, 0],
                    [0, 25.866],
                    [25.866, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [-0.04, -49.56],
                    [49.6, 0.08],
                    [-0.04, 49.72],
                    [-49.68, 0.08]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839202880859, 0.937225341797, 0.952911376953, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [249.74, 245.52], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Ellipse 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 120,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Map",
      "parent": 5,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 0,
              "s": [249.75, 245.478, 0],
              "to": [-9.433, -3.417, 0],
              "ti": [9.433, 3.417, 0]
            },
            { "t": 120, "s": [193.15, 224.978, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [249.75, 245.478, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [15.413, 43.54],
                          [15.497, 43.535],
                          [15.55, 43.456],
                          [15.65, 43.418],
                          [15.706, 43.442],
                          [15.818, 43.389],
                          [15.812, 43.254],
                          [15.728, 43.216],
                          [15.607, 43.229],
                          [15.538, 43.276],
                          [15.475, 43.346],
                          [15.439, 43.402],
                          [15.405, 43.484]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 9,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [17.913, 44.84],
                          [17.997, 44.835],
                          [18.05, 44.756],
                          [18.15, 44.718],
                          [18.206, 44.742],
                          [18.318, 44.689],
                          [18.312, 44.554],
                          [18.228, 44.516],
                          [18.107, 44.529],
                          [18.038, 44.576],
                          [17.975, 44.646],
                          [17.939, 44.702],
                          [17.905, 44.784]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 19,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [20.313, 44.94],
                          [20.397, 44.935],
                          [20.45, 44.856],
                          [20.55, 44.818],
                          [20.606, 44.842],
                          [20.718, 44.789],
                          [20.712, 44.654],
                          [20.628, 44.616],
                          [20.507, 44.629],
                          [20.438, 44.676],
                          [20.375, 44.746],
                          [20.339, 44.802],
                          [20.305, 44.884]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 29,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [30.313, 46.54],
                          [30.397, 46.535],
                          [30.45, 46.456],
                          [30.55, 46.418],
                          [30.606, 46.442],
                          [30.718, 46.389],
                          [30.712, 46.254],
                          [30.628, 46.216],
                          [30.507, 46.229],
                          [30.438, 46.276],
                          [30.375, 46.346],
                          [30.339, 46.402],
                          [30.305, 46.484]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 39,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [45.005, 33.996],
                          [39.305, 34.396],
                          [35.705, 39.696],
                          [28.905, 42.296],
                          [25.105, 40.696],
                          [17.505, 44.296],
                          [17.945, 53.416],
                          [23.645, 56.016],
                          [31.845, 55.116],
                          [36.545, 51.916],
                          [40.805, 47.196],
                          [43.205, 43.396],
                          [45.505, 37.796]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [45.005, 33.996],
                          [39.305, 34.396],
                          [35.705, 39.696],
                          [28.905, 42.296],
                          [25.105, 40.696],
                          [17.505, 44.296],
                          [17.945, 53.416],
                          [25.345, 58.716],
                          [34.445, 58.916],
                          [40.745, 57.416],
                          [43.305, 53.796],
                          [48.005, 47.096],
                          [48.805, 41.596]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 72,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [45.005, 33.996],
                          [39.305, 34.396],
                          [35.705, 39.696],
                          [28.905, 42.296],
                          [25.105, 40.696],
                          [17.505, 44.296],
                          [17.945, 53.416],
                          [30.245, 57.216],
                          [36.945, 64.616],
                          [47.045, 66.116],
                          [51.005, 62.396],
                          [52.805, 48.996],
                          [48.805, 41.596]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 119,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [45.005, 33.996],
                          [39.305, 34.396],
                          [35.705, 39.696],
                          [28.905, 42.296],
                          [25.105, 40.696],
                          [17.505, 44.296],
                          [17.945, 53.416],
                          [30.245, 57.216],
                          [36.945, 64.616],
                          [47.045, 66.116],
                          [51.005, 62.396],
                          [52.805, 48.996],
                          [48.805, 41.596]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.1, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.1, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.005, 16.896],
                    [15.545, 19.016],
                    [12.245, 20.816],
                    [11.945, 27.216],
                    [16.045, 30.216],
                    [17.045, 35.016],
                    [20.605, 37.596],
                    [22.705, 36.196],
                    [22.905, 33.196],
                    [22.105, 31.296],
                    [23.405, 29.896],
                    [27.505, 30.696],
                    [32.205, 27.796],
                    [27.405, 21.296]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [25.845, 10.332],
                          [25.845, 10.334],
                          [25.845, 10.335],
                          [25.845, 10.335],
                          [25.845, 10.336],
                          [25.846, 10.336],
                          [25.846, 10.338],
                          [25.846, 10.338],
                          [25.847, 10.338],
                          [25.848, 10.338],
                          [25.848, 10.337],
                          [25.848, 10.337],
                          [25.848, 10.337]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 9,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [29.845, 10.832],
                          [29.845, 10.834],
                          [29.845, 10.835],
                          [29.845, 10.835],
                          [29.845, 10.836],
                          [29.846, 10.836],
                          [29.846, 10.838],
                          [29.846, 10.838],
                          [29.847, 10.838],
                          [29.848, 10.838],
                          [29.848, 10.837],
                          [29.848, 10.837],
                          [29.848, 10.837]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 39,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [44.745, 18.332],
                          [44.745, 18.334],
                          [44.745, 18.335],
                          [44.745, 18.335],
                          [44.745, 18.336],
                          [44.746, 18.336],
                          [44.746, 18.338],
                          [44.746, 18.338],
                          [44.747, 18.338],
                          [44.748, 18.338],
                          [44.748, 18.337],
                          [44.748, 18.337],
                          [44.748, 18.337]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 60,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [54.445, 14.632],
                          [54.445, 14.634],
                          [54.445, 14.635],
                          [54.445, 14.635],
                          [54.445, 14.636],
                          [54.446, 14.636],
                          [54.446, 14.638],
                          [54.446, 14.638],
                          [54.447, 14.638],
                          [54.448, 14.638],
                          [54.448, 14.637],
                          [54.448, 14.637],
                          [54.448, 14.637]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 70,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [47.006, 2.296],
                          [43.405, 9.996],
                          [46.705, 15.296],
                          [47.905, 17.496],
                          [48.005, 21.496],
                          [50.705, 23.596],
                          [49.105, 30.996],
                          [51.305, 33.796],
                          [55.605, 30.296],
                          [59.505, 30.396],
                          [60.605, 28.16],
                          [60.424, 28.096],
                          [60.108, 28.277]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 82,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [47.006, 2.296],
                          [43.405, 9.996],
                          [46.705, 15.296],
                          [47.905, 17.496],
                          [48.005, 21.496],
                          [50.705, 23.596],
                          [49.105, 30.996],
                          [51.305, 33.796],
                          [55.605, 30.296],
                          [59.505, 30.396],
                          [60.605, 26.296],
                          [65.705, 28.096],
                          [74.605, 22.996]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 119,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [47.006, 2.296],
                          [43.405, 9.996],
                          [46.705, 15.296],
                          [47.905, 17.496],
                          [48.005, 21.496],
                          [50.705, 23.596],
                          [49.105, 30.996],
                          [51.305, 33.796],
                          [55.605, 30.296],
                          [59.505, 30.396],
                          [60.605, 26.296],
                          [65.705, 28.096],
                          [74.605, 22.996]
                        ],
                        "c": false
                      }
                    ],
                    "h": 1
                  }
                ],
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "t": 31,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-5.5, -26.4],
                          [-13.3, -10.5],
                          [-10, -5.2],
                          [-8.8, -3],
                          [-8.7, 1],
                          [-6, 3.1],
                          [-7.6, 10.5],
                          [-5.4, 13.3],
                          [-1.1, 9.8],
                          [2.8, 9.9],
                          [3.9, 5.8],
                          [9, 7.6],
                          [24.6, -2]
                        ],
                        "c": false
                      }
                    ],
                    "h": 1
                  },
                  {
                    "t": 47,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [6.715, -16.946],
                          [6.7, -16.915],
                          [6.707, -16.904],
                          [6.709, -16.9],
                          [-8.7, 1],
                          [-6, 3.1],
                          [-7.6, 10.5],
                          [-5.4, 13.3],
                          [-1.1, 9.8],
                          [2.8, 9.9],
                          [3.9, 5.8],
                          [9, 7.6],
                          [26.2, -3.2]
                        ],
                        "c": false
                      }
                    ],
                    "h": 1
                  },
                  {
                    "t": 84,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [5.647, -4.146],
                          [5.646, -4.146],
                          [5.647, -4.146],
                          [5.647, -4.146],
                          [5.4, -3.859],
                          [5.443, -3.826],
                          [5.418, -3.707],
                          [5.453, -3.662],
                          [5.522, -3.718],
                          [5.584, -3.717],
                          [5.602, -3.782],
                          [5.683, -3.754],
                          [5.959, -3.926]
                        ],
                        "c": false
                      }
                    ],
                    "h": 1
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 85,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [5.647, -4.146],
                          [5.646, -4.146],
                          [5.647, -4.146],
                          [5.647, -4.146],
                          [5.4, -3.859],
                          [5.443, -3.826],
                          [5.418, -3.707],
                          [5.453, -3.662],
                          [5.522, -3.718],
                          [5.584, -3.717],
                          [5.602, -3.782],
                          [5.683, -3.754],
                          [5.959, -3.926]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 95,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [10.247, 0.054],
                          [10.246, 0.054],
                          [10.247, 0.054],
                          [10.247, 0.054],
                          [10, 0.341],
                          [10.043, 0.374],
                          [10.018, 0.493],
                          [10.053, 0.538],
                          [10.122, 0.482],
                          [10.184, 0.483],
                          [10.202, 0.418],
                          [10.283, 0.446],
                          [10.559, 0.274]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 105,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [14.447, 5.254],
                          [14.446, 5.254],
                          [14.447, 5.254],
                          [14.447, 5.254],
                          [14.2, 5.541],
                          [14.243, 5.574],
                          [14.218, 5.693],
                          [14.253, 5.738],
                          [14.322, 5.682],
                          [14.384, 5.683],
                          [14.402, 5.618],
                          [14.483, 5.646],
                          [14.759, 5.474]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 115,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [19.647, 6.054],
                          [19.646, 6.054],
                          [19.647, 6.054],
                          [19.647, 6.054],
                          [19.4, 6.341],
                          [19.443, 6.374],
                          [19.418, 6.493],
                          [19.453, 6.538],
                          [19.522, 6.482],
                          [19.584, 6.483],
                          [19.602, 6.418],
                          [19.683, 6.446],
                          [19.959, 6.274]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-11.795, 13.471],
                          [-17.495, 13.871],
                          [-21.095, 19.171],
                          [-27.895, 21.771],
                          [-31.695, 20.171],
                          [-39.295, 23.771],
                          [-38.855, 32.891],
                          [-26.555, 36.691],
                          [-19.855, 44.091],
                          [-9.755, 45.591],
                          [-5.795, 41.871],
                          [-3.995, 28.471],
                          [-7.995, 21.071]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 34,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-11.795, 13.596],
                          [-17.495, 13.996],
                          [-21.095, 19.296],
                          [-27.895, 21.896],
                          [-31.695, 20.296],
                          [-39.295, 23.896],
                          [-38.855, 33.016],
                          [-26.555, 36.816],
                          [-19.855, 44.216],
                          [-9.755, 45.716],
                          [-5.795, 41.996],
                          [-3.995, 28.596],
                          [-7.995, 21.196]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 41,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-11.795, 13.596],
                          [-17.495, 13.996],
                          [-21.095, 19.296],
                          [-27.895, 21.896],
                          [-26.595, 24.296],
                          [-27.195, 27.496],
                          [-25.755, 31.716],
                          [-22.855, 35.416],
                          [-20.155, 39.316],
                          [-11.655, 43.016],
                          [-5.795, 41.996],
                          [-3.995, 28.596],
                          [-7.995, 21.196]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 45,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-11.795, 13.596],
                          [-17.495, 13.996],
                          [-21.095, 19.296],
                          [-20.837, 22.565],
                          [-20.091, 25.392],
                          [-18.964, 28.388],
                          [-17.193, 32.224],
                          [-15.431, 35.502],
                          [-13.62, 38.976],
                          [-11.655, 43.016],
                          [-5.795, 41.996],
                          [-3.995, 28.596],
                          [-7.995, 21.196]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 68,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-11.7, 13.5],
                          [-17.4, 13.9],
                          [-23.3, 19.1],
                          [-14.925, 40.497],
                          [-14.897, 40.509],
                          [-14.84, 40.483],
                          [-14.843, 40.415],
                          [-14.935, 40.386],
                          [-14.985, 40.331],
                          [-15.06, 40.32],
                          [-5.7, 41.9],
                          [-3.9, 28.5],
                          [-7.9, 21.1]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 79,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-9.382, 30.472],
                          [-9.589, 30.486],
                          [-9.802, 30.675],
                          [-9.499, 31.449],
                          [-9.498, 31.45],
                          [-9.496, 31.449],
                          [-9.496, 31.446],
                          [-9.5, 31.445],
                          [-9.501, 31.443],
                          [-9.504, 31.443],
                          [-9.165, 31.5],
                          [-9.1, 31.015],
                          [-9.245, 30.747]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 89,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-5.582, 27.072],
                          [-5.789, 27.086],
                          [-6.002, 27.275],
                          [-5.699, 28.049],
                          [-5.698, 28.05],
                          [-5.696, 28.049],
                          [-5.696, 28.046],
                          [-5.7, 28.045],
                          [-5.701, 28.043],
                          [-5.704, 28.043],
                          [-5.365, 28.1],
                          [-5.3, 27.615],
                          [-5.445, 27.347]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 99,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-0.782, 26.672],
                          [-0.989, 26.686],
                          [-1.202, 26.875],
                          [-0.899, 27.649],
                          [-0.898, 27.65],
                          [-0.896, 27.649],
                          [-0.896, 27.646],
                          [-0.9, 27.645],
                          [-0.901, 27.643],
                          [-0.904, 27.643],
                          [-0.565, 27.7],
                          [-0.5, 27.215],
                          [-0.645, 26.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 109,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [3.018, 32.072],
                          [2.811, 32.086],
                          [2.598, 32.275],
                          [2.901, 33.049],
                          [2.902, 33.05],
                          [2.904, 33.049],
                          [2.904, 33.046],
                          [2.9, 33.045],
                          [2.899, 33.043],
                          [2.896, 33.043],
                          [3.235, 33.1],
                          [3.3, 32.615],
                          [3.155, 32.347]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 119,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [8.218, 34.872],
                          [8.011, 34.886],
                          [7.798, 35.075],
                          [8.101, 35.849],
                          [8.102, 35.85],
                          [8.104, 35.849],
                          [8.104, 35.846],
                          [8.1, 35.845],
                          [8.099, 35.843],
                          [8.096, 35.843],
                          [8.435, 35.9],
                          [8.5, 35.415],
                          [8.355, 35.147]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0.1, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.1, -0.1],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-0.1, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-37.7, -3.6],
                          [-41.16, -1.48],
                          [-44.46, 0.32],
                          [-44.76, 6.72],
                          [-40.66, 9.72],
                          [-39.66, 14.52],
                          [-36.1, 17.1],
                          [-34, 15.7],
                          [-33.8, 12.7],
                          [-34.6, 10.8],
                          [-33.3, 9.4],
                          [-29.2, 10.2],
                          [-24.5, 7.3],
                          [-29.3, 0.8],
                          [-33.617, -1.461]
                        ],
                        "c": true
                      }
                    ],
                    "h": 1
                  },
                  {
                    "t": 24,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-35.767, 5.321],
                          [-35.764, 5.319],
                          [-35.76, 5.317],
                          [-35.76, 5.31],
                          [-35.764, 5.307],
                          [-35.765, 5.303],
                          [-35.769, 5.3],
                          [-35.771, 5.301],
                          [-35.771, 5.304],
                          [-35.77, 5.306],
                          [-35.772, 5.308],
                          [-35.776, 5.307],
                          [-35.78, 5.31],
                          [-35.776, 5.316],
                          [-35.771, 5.319]
                        ],
                        "c": true
                      }
                    ],
                    "h": 1
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 26,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-33.567, 3.721],
                          [-33.564, 3.719],
                          [-33.56, 3.717],
                          [-33.56, 3.71],
                          [-33.564, 3.707],
                          [-33.565, 3.703],
                          [-33.569, 3.7],
                          [-33.571, 3.701],
                          [-33.571, 3.704],
                          [-33.57, 3.706],
                          [-33.572, 3.708],
                          [-33.576, 3.707],
                          [-33.58, 3.71],
                          [-33.576, 3.716],
                          [-33.571, 3.719]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 36,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-28.567, 5.121],
                          [-28.564, 5.119],
                          [-28.56, 5.117],
                          [-28.56, 5.11],
                          [-28.564, 5.107],
                          [-28.565, 5.103],
                          [-28.569, 5.1],
                          [-28.571, 5.101],
                          [-28.571, 5.104],
                          [-28.57, 5.106],
                          [-28.572, 5.108],
                          [-28.576, 5.107],
                          [-28.58, 5.11],
                          [-28.576, 5.116],
                          [-28.571, 5.119]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 46,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-24.967, 6.121],
                          [-24.964, 6.119],
                          [-24.96, 6.117],
                          [-24.96, 6.11],
                          [-24.964, 6.107],
                          [-24.965, 6.103],
                          [-24.969, 6.1],
                          [-24.971, 6.101],
                          [-24.971, 6.104],
                          [-24.97, 6.106],
                          [-24.972, 6.108],
                          [-24.976, 6.107],
                          [-24.98, 6.11],
                          [-24.976, 6.116],
                          [-24.971, 6.119]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 56,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-17.567, 6.721],
                          [-17.564, 6.719],
                          [-17.56, 6.717],
                          [-17.56, 6.71],
                          [-17.564, 6.707],
                          [-17.565, 6.703],
                          [-17.569, 6.7],
                          [-17.571, 6.701],
                          [-17.571, 6.704],
                          [-17.57, 6.706],
                          [-17.572, 6.708],
                          [-17.576, 6.707],
                          [-17.58, 6.71],
                          [-17.576, 6.716],
                          [-17.571, 6.719]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 66,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-15.567, 8.321],
                          [-15.564, 8.319],
                          [-15.56, 8.317],
                          [-15.56, 8.31],
                          [-15.564, 8.307],
                          [-15.565, 8.303],
                          [-15.569, 8.3],
                          [-15.571, 8.301],
                          [-15.571, 8.304],
                          [-15.57, 8.306],
                          [-15.572, 8.308],
                          [-15.576, 8.307],
                          [-15.58, 8.31],
                          [-15.576, 8.316],
                          [-15.571, 8.319]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 76,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-9.567, 12.721],
                          [-9.564, 12.719],
                          [-9.56, 12.717],
                          [-9.56, 12.71],
                          [-9.564, 12.707],
                          [-9.565, 12.703],
                          [-9.569, 12.7],
                          [-9.571, 12.701],
                          [-9.571, 12.704],
                          [-9.57, 12.706],
                          [-9.572, 12.708],
                          [-9.576, 12.707],
                          [-9.58, 12.71],
                          [-9.576, 12.716],
                          [-9.571, 12.719]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 86,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-3.767, 13.521],
                          [-3.764, 13.519],
                          [-3.76, 13.517],
                          [-3.76, 13.51],
                          [-3.764, 13.507],
                          [-3.765, 13.503],
                          [-3.769, 13.5],
                          [-3.771, 13.501],
                          [-3.771, 13.504],
                          [-3.77, 13.506],
                          [-3.772, 13.508],
                          [-3.776, 13.507],
                          [-3.78, 13.51],
                          [-3.776, 13.516],
                          [-3.771, 13.519]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 96,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0.033, 15.121],
                          [0.036, 15.119],
                          [0.04, 15.117],
                          [0.04, 15.11],
                          [0.036, 15.107],
                          [0.035, 15.103],
                          [0.031, 15.1],
                          [0.029, 15.101],
                          [0.029, 15.104],
                          [0.03, 15.106],
                          [0.028, 15.108],
                          [0.024, 15.107],
                          [0.02, 15.11],
                          [0.024, 15.116],
                          [0.029, 15.119]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 106,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [4.833, 16.121],
                          [4.836, 16.119],
                          [4.84, 16.117],
                          [4.84, 16.11],
                          [4.836, 16.107],
                          [4.835, 16.103],
                          [4.831, 16.1],
                          [4.829, 16.101],
                          [4.829, 16.104],
                          [4.83, 16.106],
                          [4.828, 16.108],
                          [4.824, 16.107],
                          [4.82, 16.11],
                          [4.824, 16.116],
                          [4.829, 16.119]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 119,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [8.433, 16.521],
                          [8.436, 16.519],
                          [8.44, 16.517],
                          [8.44, 16.51],
                          [8.436, 16.507],
                          [8.435, 16.503],
                          [8.431, 16.5],
                          [8.429, 16.501],
                          [8.429, 16.504],
                          [8.43, 16.506],
                          [8.428, 16.508],
                          [8.424, 16.507],
                          [8.42, 16.51],
                          [8.424, 16.516],
                          [8.429, 16.519]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.756805419922, 0.803863525391, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 2,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [260.9, 233.8], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 8,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 120,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 249.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.999732402727, 0.999963079714, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 120,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
